import { AccountLookupService } from "../../lookup/model/impl/AccountLookupService";
import { ClientLookupService } from "../../lookup/model/impl/ClientLookupService";
import { StaticDataPrivatizationType } from "../privatization/enum/StaticDataPrivatizationType";

export class PrivatizationHelper {
  constructor(
    private clientLookupService: ClientLookupService,
    private accountLookupService: AccountLookupService,
  ) {}

  getPrivatizedValue(params: any, columnProperty: string): string {
    try {
      if (
        params != null &&
        params.data != null &&
        typeof params.data[columnProperty] === "string"
      ) {
        switch (columnProperty) {
          case "accountCode":
            if (StaticDataPrivatizationType.isRestrictedIdName(params.data)) {
              let account = this.accountLookupService.getItem(params.data[columnProperty]);
              if (account != null) {
                return account.id;
              }
            }

            if (StaticDataPrivatizationType.hasPrivatization(params.data)) {
              // name has been privatized to correct label
              return params.data["accountName"];
            }
            break;
          case "clientCode":
            if (StaticDataPrivatizationType.isRestrictedIdName(params.data)) {
              let client = this.clientLookupService.getItem(params.data[columnProperty]);
              if (client != null) {
                return client.clientId;
              }
            }

            if (StaticDataPrivatizationType.hasPrivatization(params.data)) {
              // name has been privatized to correct label
              return params.data["clientName"];
            }
            break;
          default:
            break;
        }
        return params.data[columnProperty];
      } else {
        return " ";
      }
    } catch (e) {
      return " ";
    }
  }
}
